<app-ui-reminders-timeline
    [moreActions]="moreActions"
    moreActionsButtonLabel="Settings"
    [months]="months"
    [showAddReminder]="permissionService.isAvailable('contacts.maintain-reminders.add-reminder')"
    [showChangeStatus]="permissionService.isAvailable('contacts.maintain-reminders.change-reminder-status')"
    [showViewReminder]="permissionService.isAvailable('contacts.maintain-reminders.view-reminder')"
    [showDeleteReminder]="false"
    (onMoreAction)="resolveSettingsAction($event)"
    (onCreateClick)="addReminder()"
    (onChangeStatus)="saveReminder($event)"
    (onViewReminder)="viewReminder($event)"></app-ui-reminders-timeline>
